const DefaultPagination = {
  limit: 5,
  offset: 0,
};

export default DefaultPagination;
